var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLockKey = function SvgIconLockKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 16.196a2.876 2.876 0 1 0-2 0v.679a1 1 0 1 0 2 0zm-1-3.571a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 7.25V4.875a4.375 4.375 0 0 1 8.75 0V7.25H19.5c.966 0 1.75.784 1.75 1.75v10.5a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75V9c0-.966.784-1.75 1.75-1.75zm2.696-4.054a2.375 2.375 0 0 1 4.054 1.679V7.25h-4.75V4.875c0-.63.25-1.234.696-1.68M4.75 9.25v10h14.5v-10z"
  }))));
};
export default SvgIconLockKey;